module.exports = __webpack_public_path__ + "static/img/bg.7e3a7abb.jpg";